<template>
  <KTCard :title="title" :subtitle="subTitle">
    <template v-slot:body>
      <!-- cargo form -->
      <b-form class="form" @submit.prevent="onSubmit">
        <!-- provincia -->
        <b-form-group
          label="Provincia *"
          label-for="provincia"
          description="Escriba el nombre de la provincia"
        >
          <b-form-input
            id="provincia"
            v-model="provincia.provincia"
            type="text"
            required
            placeholder="Provincia"
          ></b-form-input>
        </b-form-group>
        <!-- prefijo8 -->
        <b-form-group
          label="Prefijo 8 *"
          label-for="prefijo8"
          description="Escriba el prefijo 8 "
        >
          <b-form-input
            id="prefijo8"
            v-model="provincia.prefijo8"
            type="text"
            required
            placeholder="Prefijo 8"
          ></b-form-input>
        </b-form-group>
        <!-- prefijo9 -->
        <b-form-group
          label="Prefijo 9 *"
          label-for="prefijo9"
          description="Escriba el prefijo 9 "
        >
          <b-form-input
            id="prefijo9"
            v-model="provincia.prefijo9"
            type="text"
            required
            placeholder="Prefijo 9"
          ></b-form-input>
        </b-form-group>
        <div class="d-flex justify-content-end span-3">
          <b-button class="mr-2" @click="cancel()">Cancelar</b-button>
          <b-button type="submit" variant="primary">Guardar</b-button>
        </div>
      </b-form>
    </template>
  </KTCard>
</template>

<script>
import KTCard from "@/view/content/Card.vue";
import {
  ADD_PROVINCIA,
  EDIT_PROVINCIA
} from "@/core/services/store/provincias.module";

export default {
  name: "cargos-add",
  components: {
    KTCard
  },
  data() {
    return {
      provincia: {
        id: null,
        provincia: "",
        prefijo8: null,
        prefijo9: null
      }
    };
  },
  computed: {
    title() {
      return this.isEdit ? "Editar provincia" : "Nuevo provincia";
    },
    subTitle() {
      return this.isEdit ? "Modifique los datos" : "Escriba todos los datos";
    },
    isEdit() {
      return this.$route.params.id !== undefined;
    }
  },
  mounted() {
    if (this.isEdit) {
      this.provincia = this.$store.getters.provincia(this.$route.params.id);
    }
  },
  methods: {
    cancel() {
      this.$router.push("/lists/provincias");
    },
    onSubmit() {
      if (this.isEdit) {
        this.$store.commit(EDIT_PROVINCIA, this.provincia);
      } else {
        this.$store.commit(ADD_PROVINCIA, this.provincia);
      }
      this.cancel();
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/sass/pages/users/add";
</style>
